import { useMemo } from 'react';
import useLoginState from '../../core/hooks/useLoginState';
import getCurrentPrice from '../util/getCurrentPrice';
import { useProductPrices } from './useProductPrices';

export const useProductPrice = ({
    product,
    selectedSku,
    skip,
}: {
    product: {
        sku?: string;
        variants?: {
            sku: string;
        }[];
    };
    skip?: boolean;
    selectedSku?: string;
}) => {
    const isLoggedIn = useLoginState();

    const skuList = useMemo(() => {
        if (product.sku) {
            return [product.sku];
        } else if (product.variants) {
            return product.variants.map(variant => variant.sku);
        }
        return [];
    }, [product]);

    const { customerPrices, loading } = useProductPrices({
        skuList,
        skip,
    });

    const result = useMemo(() => {
        if (customerPrices) {
            return getCurrentPrice({
                customerPrices,
                selectedSku,
                isLoggedIn,
            });
        }

        return undefined;
    }, [customerPrices, selectedSku, isLoggedIn]);

    return {
        loading,
        startingPrice: result?.startingPrice ?? false,
        customerPrice: result?.customerPrice,
    };
};
